<template>
    <v-row justify="center" v-if="!editedItem || editedItem !== item" dense> 
      <v-col :cols="typeForm === 'search' ? '12' : '9'">
        <v-autocomplete
          dense
          outlined
          v-model="item.descriptionId"
          :items="getCoverageDescriptions"
          item-text="name"
          item-value="id"
          label="Descrição"
          :rules="typeForm === 'new' || typeForm === 'edit' ? [$util.formrules.requiredSelected] : []"
          validate-on-blur
          @change="updateItem(item, $event)"
          hide-details="true"
        ></v-autocomplete>  
      </v-col>
      <v-col v-if="typeForm !== 'search'" cols="3">
        <v-btn fab x-small @click="editItem(item)">
          <v-icon x-small title="Adicionar">fas fa-plus</v-icon>
        </v-btn>  
      </v-col>
    </v-row>
    <v-row justify="center" v-else-if="editedItem && editedItem === item" dense>
      <v-col cols="7" >
        <v-text-field
          dense
          label="Descrição"
          v-model="description"
          outlined
          hide-details="true"
        />
      </v-col>
      <v-col cols="5">  
        <v-btn fab x-small @click="saveEdition" :disabled="processing || !description" :loading="processing" >
          <v-icon  x-small title="Adicionar">fas fa-check</v-icon>
        </v-btn>
        <v-btn fab x-small @click="cancelEdition" class="ml-2">
          <v-icon x-small title="Fechar">fas fa-times</v-icon>
        </v-btn>
      </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    item: Object,
    coverageDescriptions: Array,
    typeForm: String,
  },
  data() {
    return {
      editedItem: null,
      description: null,
      processing: false
    };
  },
  mounted () {
    this.fetchCoverageDescriptions();
  },
  computed: {
    ...mapGetters("coverage", ["getCoverageDescriptions"]),
  },
  methods: {
    ...mapActions("coverage", ["createCoverageDescription", "fetchCoverageDescriptions"]),
    editItem(item) {
      this.editedItem = item;
    },
    cancelEdition() {
      this.editedItem = null
    },
    async saveEdition() {
      this.processing = true;
      let coverageDescription = await this.createCoverageDescription(
        {
          coverageDescription: { name: this.description }
        }
      );
      this.updateItem(this.editedItem, coverageDescription ? coverageDescription.id : null);
      this.editedItem.descriptionId = coverageDescription ? coverageDescription.id : null;
      this.description = null;
      this.processing = false;
      this.cancelEdition();
    },
    updateItem(item, coverageDescriptionId) {
      this.$emit("on-description-created", item, coverageDescriptionId);
    }
  }
};
</script>
